import React, { useState, useEffect, useRef } from "react";
import "./sideBar.css";
import { useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";

function Sidebar({ isMobile, toggleMenu, isMenuOpen, onSideMenupChange }) {
  const location = useLocation();
  const roleName = useSelector((state) => state.user.roleName);

  useEffect(() => {
    let pathToMenuId = {};
    if (roleName == "super_admin") {
      pathToMenuId = {
        "/": 1,
        "/my-profile": 2,
        "/customer-list": 3,
        "/advisor-list": 4,
        "/investment-list": 5,
        "/investment-request-list": 6,
        "/stock-list": 7,
        "/product-approval": 8,
        "/inspecie-transfer-request": 9,
        "/product-settings": 10,
        "/roles-permissions": 11,
      };
    } else if (roleName == "advisor") {
      pathToMenuId = {
        "/": 1,
        "/my-profile": 2,
        "/customer-list": 3,
        "/sub-advisor-list": 4,
        "/investment-list": 5,
        "/stock-list": 6,
      };
    } else if (roleName == "team") {
      pathToMenuId = {
        "/": 1,
        "/customer-list": 2,
      };
    } else if (roleName == "sub_advisor") {
      pathToMenuId = {
        "/": 1,
        "/my-profile": 2,
        "/customer-list": 3,
        "/investment-list": 4,
        "/stock-list": 5,
      };
    } else {
      pathToMenuId = {
        "/": 1,
        "/my-profile": 2,
        "/customer-list": 3,
        "/investment-list": 4,
        "/investment-request-list": 5,
        "/stock-list": 6,
        "/product-approval": 7,
        "/inspecie-transfer-request": 8,
        "/product-settings": 9,
      };
    }

    const currentMenuId = pathToMenuId[location.pathname];
    if (currentMenuId) {
      setSelectedItem(currentMenuId);
      localStorage.setItem("sideOption", currentMenuId);
    }
  }, [location.pathname]);
  const handleChange = () => {
    toggleMenu();
  };
  let menuItems = [];
  if (roleName == "super_admin") {
    menuItems = [
      {
        id: 1,
        label: "Dashboard",
        defaultIcon: "/dashboard-black.svg", // Replace with your default icon URL
        selectedIcon: "/element-dashboard.svg", // Replace with your selected icon URL
      },
      {
        id: 2,
        label: "My Profile",
        defaultIcon: "/profile-black.svg",
        selectedIcon: "/profile-white.svg",
      },
      {
        id: 3,
        label: "Customers",
        defaultIcon: "/customer-black.svg",
        selectedIcon: "/profile-2user.svg",
      },
      {
        id: 4,
        label: "Advisors",
        defaultIcon: "/customer-black.svg",
        selectedIcon: "/profile-2user.svg",
      },

      {
        id: 5,
        label: "Investment menu",
        defaultIcon: "/dollar-circle.svg",
        selectedIcon: "/investment-white.svg",
      },
      {
        id: 6,
        label: "Investment Requests",
        defaultIcon: "/money-receive.svg",
        selectedIcon: "/money-receive-white.svg",
      },
      {
        id: 7,
        label: "Stock Purchases",
        defaultIcon: "/stock-black.svg",
        selectedIcon: "/stock-white.svg",
      },
      {
        id: 8,
        label: "Product Approvals",
        defaultIcon: "/chart-success-black.svg",
        selectedIcon: "/chart-success-white.svg",
      },
      {
        id: 9,
        label: "Inspecie Transfer Request",
        defaultIcon: "/download-icon.svg",
        selectedIcon: "/download-icon-white.svg",
      },
      {
        id: 10,
        label: "Product Settings",
        defaultIcon: "/unselected-settings.svg",
        selectedIcon: "/selected-settings.svg",
      },

      {
        id: 11,
        label: "Roles & Permissions",
        defaultIcon: "/sheild-black.svg",
        selectedIcon: "/shield-white.svg",
      },
    ];
  } else if (roleName == "advisor") {
    menuItems = [
      {
        id: 1,
        label: "Dashboard",
        defaultIcon: "/dashboard-black.svg", // Replace with your default icon URL
        selectedIcon: "/element-dashboard.svg", // Replace with your selected icon URL
      },
      {
        id: 2,
        label: "My Profile",
        defaultIcon: "/profile-black.svg",
        selectedIcon: "/profile-white.svg",
      },
      {
        id: 3,
        label: "Customers",
        defaultIcon: "/customer-black.svg",
        selectedIcon: "/profile-2user.svg",
      },
      {
        id: 4,
        label: "Sub Advisors",
        defaultIcon: "/customer-black.svg",
        selectedIcon: "/profile-2user.svg",
      },
      {
        id: 5,
        label: "Investment menu",
        defaultIcon: "/dollar-circle.svg",
        selectedIcon: "/investment-white.svg",
      },
      {
        id: 6,
        label: "Stock Purchases",
        defaultIcon: "/stock-black.svg",
        selectedIcon: "/stock-white.svg",
      },
    ];
  } else if (roleName == "sub_advisor") {
    menuItems = [
      {
        id: 1,
        label: "Dashboard",
        defaultIcon: "/dashboard-black.svg", // Replace with your default icon URL
        selectedIcon: "/element-dashboard.svg", // Replace with your selected icon URL
      },
      {
        id: 2,
        label: "My Profile",
        defaultIcon: "/profile-black.svg",
        selectedIcon: "/profile-white.svg",
      },
      {
        id: 3,
        label: "Customers",
        defaultIcon: "/customer-black.svg",
        selectedIcon: "/profile-2user.svg",
      },
      {
        id: 4,
        label: "Investment menu",
        defaultIcon: "/dollar-circle.svg",
        selectedIcon: "/investment-white.svg",
      },
      {
        id: 5,
        label: "Stock Purchases",
        defaultIcon: "/stock-black.svg",
        selectedIcon: "/stock-white.svg",
      },
    ];
  } else if (roleName == "team") {
    menuItems = [
      {
        id: 1,
        label: "My Profile",
        defaultIcon: "/profile-black.svg",
        selectedIcon: "/profile-white.svg",
      },
      {
        id: 2,
        label: "Customers",
        defaultIcon: "/customer-black.svg",
        selectedIcon: "/profile-2user.svg",
      },
    ];
  } else {
    menuItems = [
      {
        id: 1,
        label: "Dashboard",
        defaultIcon: "/dashboard-black.svg", // Replace with your default icon URL
        selectedIcon: "/element-dashboard.svg", // Replace with your selected icon URL
      },
      {
        id: 2,
        label: "My Profile",
        defaultIcon: "/profile-black.svg",
        selectedIcon: "/profile-white.svg",
      },
      {
        id: 3,
        label: "Customers",
        defaultIcon: "/customer-black.svg",
        selectedIcon: "/profile-2user.svg",
      },

      {
        id: 4,
        label: "Investment menu",
        defaultIcon: "/dollar-circle.svg",
        selectedIcon: "/investment-white.svg",
      },
      {
        id: 5,
        label: "Investment Requests",
        defaultIcon: "/money-receive.svg",
        selectedIcon: "/money-receive-white.svg",
      },
      {
        id: 6,
        label: "Stock Purchases",
        defaultIcon: "/stock-black.svg",
        selectedIcon: "/stock-white.svg",
      },
      {
        id: 7,
        label: "Product Approvals",
        defaultIcon: "/chart-success-black.svg",
        selectedIcon: "/chart-success-white.svg",
      },
      {
        id: 8,
        label: "Inspecie Transfer Request",
        defaultIcon: "/download-icon.svg",
        selectedIcon: "/download-icon-white.svg",
      },
      {
        id: 9,
        label: "Product Settings",
        defaultIcon: "/unselected-settings.svg",
        selectedIcon: "/selected-settings.svg",
      },

      // {
      //   id: 8,
      //   label: "Alerts",
      //   defaultIcon: "/alert-black.svg",
      //   selectedIcon: "/alert-white.svg",
      // },
    ];
  }

  const [selectedItem, setSelectedItem] = useState(
    Number(localStorage.getItem("sideOption")) || 1
  );
  const [hoveredItem, setHoveredItem] = useState(null);

  const handleChangeMenu = (id) => {
    localStorage.setItem("sideOption", Number(id));
    setSelectedItem(id);
    onSideMenupChange(id);
    toggleMenu();
  };
  const [isImageLoaded, setImageLoaded] = React.useState(false);

  return (
    <div
      className={`lg:block flex-1
    ${
      isMobile
        ? isMenuOpen
          ? "bg-[#F9F9F9] translate-x-0 fixed w-full z-10 top-0 left-0 h-full transition-transform duration-300 "
          : "hidden  translate-x-0   h-full -translate-x-full"
        : "text-black top-0 left-0  w-auto h-full"
    }`}
    >
      <div
        className={`md:w-[18vw] 
    ${isMobile && isMenuOpen ? "w-full" : "w-auto"}`}
      >
        {/* Company Logo */}
        <div className="pr-4 pl-4 flex flex-col items-center">
          <div className="relative w-auto h-20 flex items-center justify-center">
            {/* Shimmer effect */}
            <div
              className={`absolute inset-0 bg-gray-200 animate-pulse ${
                isImageLoaded ? "hidden" : "block"
              }`}
            ></div>
            {/* Actual Image */}
            <img
              src="/Caprock-Logo2.svg" // Replace with your logo URL
              alt="Company Logo"
              className={`w-auto top-20 ${isImageLoaded ? "block" : "hidden"}`}
              onLoad={() =>
                setTimeout(function () {
                  setImageLoaded(true);
                }, 100)
              }
            />
          </div>
          {/* Text Below Logo */}
          <p className="pl-4 pr-4 font-medium bg-black text-white drop-shadow-md border-radius-admin-heading">
            {roleName == "advisor" ? "Advisor Dashboard" : "Admin Dashboard"}
          </p>
        </div>

        {/* Menu List */}
        {isImageLoaded && (
          <ul className="mt-4 font-medium p-4">
            {menuItems.map((item) => (
              <li
                key={item.id}
                onMouseEnter={() => setHoveredItem(item.id)}
                onMouseLeave={() => setHoveredItem(null)}
                onClick={() => handleChangeMenu(item.id)} // Set selected item on click
                className={`flex items-center mb-4 pl-4 drop-shadow-md border-radius-menu-selected px-6 py-3 cursor-pointer ${
                  selectedItem === item.id || hoveredItem === item.id
                    ? "bg-black text-white"
                    : ""
                }`}
              >
                {/* Icon */}
                <img
                  src={
                    selectedItem === item.id || hoveredItem === item.id
                      ? item.selectedIcon
                      : item.defaultIcon
                  }
                  alt={`${item.label} Icon`}
                  className={`mr-2 inset-0 w-6 h-6  object-contain transition-transform duration-300 ${
                    hoveredItem === item.id ? "scale-110" : "scale-100"
                  }`}
                />
                {/* Label */}
                <span>{item.label}</span>
              </li>
            ))}
          </ul>
        )}

        {isMobile && isMenuOpen && (
          <div className="absolute bottom-0 left-0 w-full flex justify-center items-center py-4">
            <button
              onClick={handleChange}
              className="px-2 py-2 bg-black rounded-full shadow-md"
            >
              <img src="/add.svg" alt="Close" className="w-10 h-10" />
            </button>
          </div>
        )}
      </div>
    </div>
  );
}

export default Sidebar;
